/**
 * @file Highlight-style.ts
 * @module HighlightStyle
 * @description OpenLayers stilu definīcijas objektu hover/atlases izcēlumam.
 *              Nodrošina daļēji caurspīdīgu zilu aizpildījumu ar cietu zilu kontūru —
 *              noklusējuma izcēlums, kad lietotājs virza peli virs kartes objektiem.
 */

import { Icon, Style } from "ol/style";
import highlightR from "../shared/img/highlight-r.png";
import highlightS from "../shared/img/highlight-s.png";
import borderCMS from "../shared/img/border-cms.png";
import { ENTRYPOINT, IS_LOCALHOST } from "./Endpoints";

/**
 * Creates a highlight glow border style for standard point features.
 * @param square - If true, uses a square highlight border; otherwise uses round
 */
export const getPointHighlight = (square?: boolean) => {
	const style = new Style({
		image: new Icon({
			src: square ? highlightS : highlightR,
			scale: 0.75,
		}),
		zIndex: -Infinity,
	});
	//@ts-expect-error
	style.isHighlighted_ = true;
	return style;
};

/** Creates a highlight border style specifically for CMS device icons (anchored at bottom center) */
export const getCMSHighlight = () => {
	const style = new Style({
		image: new Icon({
			src: borderCMS,
			scale: 1,
			anchor: [0.5, 1.4],
		}),
		zIndex: -Infinity,
	});
	//@ts-expect-error
	style.isHighlighted_ = true;
	return style;
};

/**
 * Creates a temperature badge icon for CMS stations showing the air temperature.
 * The icon filename is determined by rounding the t1 value (e.g., c_cms_temperatura5.png).
 * @param t1 - Air temperature value from the CMS sensor
 */
export const getCMSMeteo = (t1: string) => {
	const url =
		(IS_LOCALHOST ? ENTRYPOINT.replace("/gis", "") : window.location.origin.replace("map-", "npp-").replace("sipr-test", "sipr")) +
		"/gfiles/visualization/cms/c_cms_temperatura" +
		Math.round(Number(t1)) +
		".png";

	const style = new Style({
		image: new Icon({
			src: url,
			scale: 1,
			anchor: [0.5, 1.6],
		}),
		zIndex: -Infinity,
	});
	//@ts-expect-error
	style.isHighlighted_ = true;
	return style;
};
